import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';
import { MODALS_NS } from './i18n';

interface ErrorModalProps {
  open: boolean;
  onClose: () => void;
  onRetry?: () => void;
  title?: string;
  message: string;
}

export const ErrorModal = ({ open, onClose, onRetry, message, title }: ErrorModalProps) => {
  const { t } = useTranslation(MODALS_NS);
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Box
          sx={{
            borderRadius: '50%',
            border: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'error.muted',
            width: 40,
            height: 40,
          }}
        >
          <InfoOutlinedIcon color="error" />
        </Box>
      </DialogTitle>
      <DialogContent
        sx={{
          minWidth: 553,
        }}
      >
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontSize: '16px',
                fontWeight: 500,
                mb: 1,
              }}
            >
              {title}
            </Typography>
            {message}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('error.cancel')}</Button>
        {onRetry && (
          <Button onClick={onRetry} variant="contained" color="primary">
            {t('error.tryAgain')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
